import { useSelector } from "react-redux";
import { columnTypes } from "../shared/table/columnTypes";
import { PreservableStateLink } from "../shared/PreservableStatePageWrapper";
import { Tooltip } from "antd";

export const manageRemindersColumns = () => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Policy",
      dataIndex: "PolicyNumber",
      type: columnTypes.TEXT,
      width: 85,
      render: (value, record) => (
        <PreservableStateLink
          to={`/managereminders/reminderform/${record.RequestID}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Plate",
      dataIndex: "PlateNumber",
      type: columnTypes.TEXT,
      width: 72,
      render: (value, record) => (
        <PreservableStateLink
          to={`/managereminders/reminderform/${record.RequestID}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Updated Date",
      dataIndex: "UpdatedDate",
      type: columnTypes.DATETIME,
      width: 180,
    },
    {
      title: "Assigned To",
      dataIndex: "AssignedTo",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Processing Stage",
      dataIndex: "ProcessingStageDesc",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Latest Note",
      dataIndex: "Note",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Expiry Date",
      dataIndex: "PolicyExpiryDate",
      type: columnTypes.DATE,
      width: 95,
    },

    {
      title: "Insured",
      dataIndex: "InsuredName",
      type: columnTypes.TEXT,
      width: 250,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Status",
      dataIndex: "PolicyStatusDesc",
      type: columnTypes.TEXT,
      width: 105,
    },

    {
      title: "PC1",
      dataIndex: "ProducerCode1",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 1",
      dataIndex: "ProducerName1",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "PC2",
      dataIndex: "ProducerCode2",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 2",
      dataIndex: "ProducerName2",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Phone",
      dataIndex: "CustomerHomePhone",
      type: columnTypes.PHONE,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 95,
    },
    {
      title: "Reminder Profile",
      dataIndex: "ReminderProfile",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Agency",
      dataIndex: "AgencyNumberAndName",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Reminder Status",
      dataIndex: "RequestStatusDesc",
      type: columnTypes.TEXT,
      width: 120,
    },
  ];
};

export const emailMessagesColumns = (onMessageClick) => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Subject",
      dataIndex: "Subject",
      type: columnTypes.TEXT,
      width: 100,
      render: (_, record) => (
        <a onClick={() => onMessageClick(record.Body)}>{record.Subject}</a>
      ),
    },
    {
      title: "Type",
      dataIndex: "ReasonDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "Sent Date",
      dataIndex: "UpdatedDate",
      type: columnTypes.DATE,
      width: 60,
    },
    {
      title: "Delivery Status",
      dataIndex: "DeliveryStatusDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "To",
      dataIndex: "Email",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 60,
    },
  ];
};

export const agentNotesColumns = () => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Note",
      dataIndex: "Note",
      type: columnTypes.TEXT,
      width: 100,
    },
    {
      title: "Processing Stage",
      dataIndex: "ProcessingStageDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "Agent",
      dataIndex: "AgentName",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "UpdatedDate",
      type: columnTypes.DATE,
      width: 60,
    },
  ];
};
